module.exports = __webpack_public_path__ + "4ed6bfb992dd828bab041ae51f78615b.png";